

















































































































import Vue from "vue"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import { countryCurrencyLimit } from "@/enums/country-currency-limit"

interface Form {
  reference: string
}

export interface ICodGroup extends Vue {
  amount: number | null
  form: Form
  codType: string
  amountArray: number[]

  clearAll(): void
}

export default Vue.extend({
  data() {
    return {
      form: {
        reference: ""
      },
      codType: "103",
      amount: null,
      amountArray: [undefined] as any,
      rules: {
        reference: [{ required: true, message: this.$t("new.parcel.error.cod_reference_mandatory"), trigger: "change" }]
      }
    }
  },
  props: {
    parcelNumber: {
      type: Number,
      required: true
    },
    country: {
      type: Object,
      required: true
    },
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    codValidated: {
      type: Boolean,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearAll() {
      this.form.reference = ""
      this.codType = "103"
      this.amount = 0
      this.amountArray = [0]
    },
    emitValidation() {
      this.$emit(
        "update:codValidated",
        !this.createParcelModel.createParcelModelExtensions.cashOnDelivery.value ||
          (exists(this.form.reference) &&
            this.form.reference !== "" &&
            !this.referenceDisabled &&
            this.createParcelModel.createParcelModelExtensions.cashOnDelivery.value)
      )
    },
     calculateCurrencyLimit(currency: string) {
        const countryLimit = countryCurrencyLimit.find(((val) => val.currency === currency))
        return countryLimit ? countryLimit.limit : null
    },
    checkIfAmountExistsAndHasCorrectFormat(amount: any) {
      return exists(amount) && amount.toString().match(/^[0-9]*\.?[0-9]{0,2}$/)
    },
    maxAmountValidation(amount: any) {
      const limit = this.calculateCurrencyLimit(this.country.currency)
      return amount > limit
    },
    minAmountValidation(amount: any) {
      const minValue = 0
      return amount <= minValue
    },
    checkIfAmountIsEmptyWhenEveryParcelHasDifferentAmount() {
      return (this.codType === "101" &&
          (!exists(this.amountArray) || !exists(this.amountArray.find((amount: any) => notEmpty(amount)))))
    },
    checkForCorrectValidationWhenEveryParcelHasDifferentAmount() {
      return  (
        this.codType === "101" &&
          (    !notEmpty(this.amountArray)
           || (!!this.amountArray.find((amount: any) =>
               !this.checkIfAmountExistsAndHasCorrectFormat(amount)))
               || (!!this.amountArray.find((amount: any) => this.maxAmountValidation(amount)))
          )
        )
    },
    checkForCorrectValidationWhenEveryParcelDoesntHaveDifferentAmount() {
      return (
          this.codType !== "101" &&
          (    !notEmpty(this.amount)
            || !this.checkIfAmountExistsAndHasCorrectFormat(this.amount)
            || this.maxAmountValidation(this.amount)
            || this.minAmountValidation(this.amount)
          )
      )
    }
  },

  computed: {
    referenceDisabled(): boolean {
      return (
        !this.hasProductVariant ||
        this.readonly ||
        this.checkForCorrectValidationWhenEveryParcelDoesntHaveDifferentAmount() ||
        this.checkForCorrectValidationWhenEveryParcelHasDifferentAmount() ||
        this.checkIfAmountIsEmptyWhenEveryParcelHasDifferentAmount()
      )
    }
  },
  watch: {
    amount: {
      handler() {
        this.emitValidation()
      }
    },
    amountArray: {
      deep: true,
      handler() {
        this.emitValidation()
      }
    },
    "form.reference": {
      handler() {
        this.emitValidation()
      }
    },
    "createParcelModel.createParcelModelExtensions.cashOnDelivery.value": {
      handler() {
        this.emitValidation()
      }
    },
    parcelNumber: {
      handler(newVal: number) {
        this.amountArray = this.amountArray.splice(newVal)
        for (let index = 0; index < this.parcelNumber; index++) {
          if (!exists(this.amountArray[index])) {
            this.amountArray[index] = undefined
          }
        }
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
